import loadable from '@loadable/component'

export default [
  {
    path: '/PartyGala/data/:id',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-data" */ '~/pages/PartyGala/pages/data'
        )
    ),
  },
  {
    path: '/PartyGala/banner',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-banner" */ '~/pages/PartyGala/pages/banner'
        )
    ),
  },
  {
    path: '/PartyGala/create',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-create" */ '~/pages/PartyGala/pages/create'
        )
    ),
  },
  {
    path: '/PartyGala/createKing',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-createKing" */ '~/pages/PartyGala/pages/createKing'
        )
    ),
  },
  {
    path: '/PartyGala/activity',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-activity" */ '~/pages/PartyGala/pages/activity'
        )
    ),
  },
  {
    path: '/PartyGala/square',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-square" */ '~/pages/PartyGala/pages/square'
        )
    ),
  },
  {
    path: '/PartyGala/schedule',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-PartyGala-schedule" */ '~/pages/PartyGala/pages/schedule'
        )
    ),
  },
]
